// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { auditEventsResponseSchema } from '@/audit/api/types';

export const organizationAuditEvents = [
  'ORGANIZATION_CREATE',
  'ORGANIZATION_UPDATE',
  'ORGANIZATION_ACCOUNTING_UPDATE',
  'ORGANIZATION_ATTENTION_THRESHOLD_UPDATE',
  'ORGANIZATION_MEMBER_UPDATE',
  'EXTERNAL_USER_CREATE',
  'EXTERNAL_USER_UPDATE',
  'EXTERNAL_USER_DELETE',
  'PROJECT_WORKFLOW_CREATED',
  'PROJECT_WORKFLOW_UPDATED',
  'PROJECT_WORKFLOW_DELETED',
];

export const organizationDeleteAuditEvents = ['PROJECT_DELETE', 'NOTE_DELETE'];

export const crmAuditEvents = [
  'INTEGRATION_CONNECTED',
  'CRM_SYNC_TRIGGER',
  'CRM_PROPERTY_MAPPINGS',
  'CRM_SYNC_TOGGLE',
  'CRM_SYNC_RUN',
  'CRM_PROCESSING_SUCCESS',
  'CRM_PROCESSING_SKIP',
  'CRM_PROCESSING_FAILURE',
];

export const apiAuditEvents = [];

/**
 * Request a list of audit events for a organization from the remote API.
 *
 * @param key - The key of the organization for which to request audit events.
 * @param eventTypes - list of event types to use
 */
export async function getOrganizationAuditEvents(
  key: string,
  eventTypes?: string[]
) {
  const searchParams = new URLSearchParams();
  if (eventTypes) {
    eventTypes.forEach((event) => {
      searchParams.append('events', event);
    });
  }
  const url = `/v1/organization/${key}/audit${searchParams.toString() ? `?${searchParams.toString()}` : ''}`;
  const response = await api.get(url);

  return parseResponse(auditEventsResponseSchema, response.data, {
    schemaName: 'OrganizationAuditEvents',
    endpoint: url,
  });
}
